import invariant from 'invariant';
import get from 'lodash/get';

import type { AppConfig } from './types/AppConfig';

let config: AppConfig;

export function configValue(...path: string[]): string | null | undefined {
  return get(config, path);
}

export function requiredConfig<T>(...path: string[]): T {
  const value = get(config, path);
  invariant(value, `Config value ${path.toString()} is required`);

  return value as T;
}

export function configString(...path: string[]): string {
  const value = requiredConfig(...path);
  return typeof value === 'string' ? value : '';
}

export function setConfigOnce(newConfig: AppConfig) {
  if (!config) {
    config = newConfig;
  }
}

// eslint-disable-next-line no-underscore-dangle
export function _getConfigForFetchUserEnvironment() {
  return config;
}
